let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1Bhy2")).then(() => parcelRequire('4xWO8'));